import { NavPills } from 'app/components';
import { Route, Switch, useRouteMatch, useParams } from 'react-router-dom';
import { i18n } from 'app/utils/i18n';
import { Overview } from './Overview/Overview';
import { Extensions } from './Extensions/Extensions';
import { Export } from './Export/Export';
import { Taxonomies } from './Taxonomies/Taxonomies';
import { Categories } from './Categories/Categories';
import { Mandatory } from './Mandatory/Mandatory';
import { TreeOverview } from './TreeOverview/TreeOverview';
import { useState } from 'react';
import { DetailsModal, DetailsTagConcept } from 'app/components/editor/sidebar/tags/Modal/DetailsModal';
import { TagWithMetadata } from 'app/api/tag-queries';
import { getTagLabel } from 'app/utils/tag-utils';
import { TagContextProvider } from 'app/state/contexts/TagContext';

export const TaggingSettings = () => {
  const { path, url } = useRouteMatch();
  const { documentId } = useParams<{ documentId: string }>();
  const [detailsModalTag, setDetailsModalTag] = useState<DetailsTagConcept | null>(null);

  const items = [
    { text: i18n('tag.tags.label'), url: `${url}` },
    { text: i18n('tag.mandatory.tags'), url: `${url}/mandatory` },
    { text: i18n('tag.taxonomy.plural'), url: `${url}/taxonomies` },
    { text: i18n('tag.categories.label'), url: `${url}/categories` },
    { text: i18n('tag.extensions.label'), url: `${url}/extensions` },
    { text: i18n('tag.treeOverview.label'), url: `${url}/tree` },
    { text: i18n('tag.export.label'), url: `${url}/export` },
  ];

  const onTagDetailsClick = (tag: TagWithMetadata) => {
    setDetailsModalTag({
      id: tag.id,
      name: tag.concept?.name ?? '',
      conceptType: tag.concept?.conceptType ?? undefined,
      label: getTagLabel({ languages: tag.concept?.labels ?? {}, currentLang: 'sv' }),
      notes: tag?.notes ?? undefined,
    });
  };

  return (
    <TagContextProvider>
      <div className="mt-5">
        <NavPills items={items as any} className="d-inline-flex" />
      </div>

      <Switch>
        <Route path={`${path}`} exact>
          <Overview documentId={documentId} onTagDetailsClick={onTagDetailsClick} />
        </Route>
        <Route path={`${path}/taxonomies`}>
          <Taxonomies documentId={documentId} />
        </Route>
        <Route path={`${path}/categories`}>
          <Categories documentId={documentId} />
        </Route>
        <Route path={`${path}/extensions`}>
          <Extensions documentId={documentId} onTagDetailsClick={onTagDetailsClick} />
        </Route>
        <Route path={`${path}/tree`}>
          <TreeOverview documentId={documentId} />
        </Route>
        <Route path={`${path}/mandatory`}>
          <Mandatory documentId={documentId} onTagDetailsClick={onTagDetailsClick} />
        </Route>
        <Route path={`${path}/export`}>
          <Export documentId={documentId} onTagDetailsClick={onTagDetailsClick} />
        </Route>
      </Switch>

      {/* This modal is used throughout the tagging settings when clicking "details" on a tag, therefore it is placed here to be accessible from all sub-routes */}
      <DetailsModal show={!!detailsModalTag} tagConcept={detailsModalTag} onClose={() => setDetailsModalTag(null)} />
    </TagContextProvider>
  );
};
